module.exports = "././img/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 834
// module chunks = 0